// 📄 pages/MiEspacio/miEspacioContexto.ts
// Props compartidas por las 4 secciones de Mi Espacio (Snippets, Notas de
// SAP, Tareas, Contactos): en qué contexto(s) leer, dónde guardar lo nuevo,
// y cómo etiquetar cada tarjeta cuando se mezclan varios proyectos (vista
// consolidada del Home, ver MiEspacioHome.tsx).
export interface MiEspacioSeccionProps {
  // Contextos a consultar — null es el espacio Global/Freelance, un
  // projectId consulta usuarios/{uid}/projectData/{projectId}/{coleccion}.
  // Puede traer varios a la vez (ej. [null, 'proyA', 'proyB'] para "Todos").
  contextosConsulta: (string | null)[];
  // Dónde se guarda un item NUEVO creado desde esta vista (al editar uno
  // existente, se usa su propio `projectId`, nunca este).
  contextoNuevo: string | null;
  // Mapa projectId -> nombre del proyecto, para el badge de contexto.
  proyectosPorId: Record<string, string>;
  // Solo tiene sentido mostrar el badge "Global / Proyecto X" cuando la
  // vista mezcla contextos (Home con filtro "Todos") — dentro de un
  // proyecto, con un único contexto fijo, sería ruido redundante.
  mostrarProyecto?: boolean;
}

export const etiquetaContexto = (projectId: string | null, proyectosPorId: Record<string, string>): string =>
  projectId ? (proyectosPorId[projectId] || 'Proyecto') : 'Global / Freelance';
